const GET_REASON_TYPE = 'GET_REASON_TYPE';
const SET_REASON_TYPE = 'SET_REASON_TYPE';

export
{
    GET_REASON_TYPE,
    SET_REASON_TYPE
};
